module.exports = __webpack_public_path__ + "img/hk_product@3x.82535afb.png";